import * as React from 'react';
import { useField, useFormikContext, FieldConfig, ErrorMessage } from 'formik';
import DatePicker from 'react-datepicker';
import cn from 'classnames';
import { InquiryFormInterface } from '../InquiryForm';

interface DatePickerFieldProps {
    label: string;
}

const DatePickerField = ({ ...props }: FieldConfig & DatePickerFieldProps) => {
    const { setFieldValue, values } = useFormikContext<InquiryFormInterface>();
    const [field, meta] = useField(props);
    return (
        <div className='MaterialTextInput MaterialDatePickerInput'>
            <DatePicker
                {...field}
                {...props}
                className={cn('MaterialTextInput--input', {
                    'MaterialTextInput--input__has-error': !field.value && !values.checkbox && meta.touched,
                })}
                selected={field.value || null}
                onBlur={() => {}}
                minDate={new Date()}
                onChange={(val) => {
                    setFieldValue(field.name, val);
                    setFieldValue('checkbox', null);
                }}
            />
            <div className='MaterialTextInput--bar' />
            <label className={'MaterialTextInput--label' + (field.value ? ' MaterialTextInput--label__active' : '')}>{props.label}</label>
            <ErrorMessage name='date'>{(msg) => <div className='InputText--error'>{msg}</div>}</ErrorMessage>
        </div>
    );
};

export default DatePickerField;
